/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { Link } from 'react-router-dom';
export var Breadcrumbs = function (_a) {
    var className = _a.className, items = _a.items;
    return (jsx("div", { sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            color: 'muted',
            fontSize: 1,
        }, className: className }, items.map(function (item) { return (jsx(Fragment, { key: item.url },
        jsx(FontAwesomeIcon, { icon: faChevronLeft }),
        ' ',
        jsx(Link, { sx: {
                mx: 2,
                color: 'muted',
                textDecoration: 'none',
            }, to: item.url }, item.title),
        ' ')); })));
};
//# sourceMappingURL=Breadcrumbs.js.map